"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// scripts
require("./MenuToolbarDirective");
require("./NotifyDirective");
require("./ListControlDirective");
require("./PaginationDirective");
require("./SwitchDirective");
require("./DatepickerDirective");
require("./AutoheightDirective");
require("./DropdownDirective");
require("./ScrollClassDirective");
require("./AutofocusDirective");
require("./PriceServiceDirective");
require("./SideCartDirective");
require("./TooltipDirective");
exports.default = angular.module('rinca.core.directives', [
    'rinca.core.directives.menu-toolbar',
    'rinca.core.directives.notify',
    'rinca.core.directives.list-control',
    'rinca.core.directives.pagination',
    'rinca.core.directives.switch',
    'rinca.core.directives.datepicker',
    'rinca.core.directives.autoheight',
    'rinca.core.directives.dropdown',
    'rinca.core.directives.scroll-class',
    'rinca.core.directives.autofocus',
    'rinca.core.directives.priceSettings',
    'rinca.core.directives.sidecart',
    'rinca.core.directives.tooltip'
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/index.ts
// module id = 297
// module chunks = 0